/** Checkout settings: shipping price, listing terms, notifications, countries, sender and payment methods. */
export default {
    shared: {
        defaultLocale: '(def)',
    },
    returnFees: {
        free: 'Free returns',
        customer: 'Customer pays the postage',
        fixed: 'Fixed return fee',
    },
    settings: {
        saved: 'Checkout settings saved',
        save: 'Save checkout settings',
    },
    shipping: {
        title: 'Shipping',
        introModule: 'Charged when no rate in the rate table matches the address. Turn on "Only accept orders we can deliver" below to refuse those orders instead.',
        introFlat: "Flat shipping rate applied to every order. Leave the free-shipping threshold blank to always charge the flat rate; enter an amount to waive shipping when an order's gross total (incl. tax) reaches it.",
        cents: 'All amounts in cents (e.g. {example} = €4.95).',
        noRateMatch: 'Price when no rate matches (cents)',
        flatRate: 'Flat shipping rate (cents)',
        freeThreshold: 'Free shipping threshold (cents)',
        freeThresholdPlaceholder: 'Leave blank to disable',
        requireSelection: 'Only accept orders we can deliver',
        requireSelectionHint: 'Refuse checkout when the rate table has no option for the address, for a business that delivers itself inside its own postcodes. Off, such an order is charged the price above. Needs at least one zone.',
    },
    google: {
        title: 'Google shopping listings',
        intro: 'Stated in every product\'s structured data, so Google can show products in its free shopping listings with delivery time and return terms. Blank means "not stated": Google is told nothing rather than a guess. Days are working days.',
        defaultBrand: 'Default brand',
        defaultBrandHint: 'For products that name no brand of their own',
        handlingMin: 'Handling time, min days',
        handlingMinHint: 'Order to parcel handed over; 0 = same day',
        handlingMax: 'Handling time, max days',
        transitMin: 'Transit time, min days',
        transitMinHintModule: 'For rates that state no delivery time of their own',
        transitMinHint: 'Carrier time to the customer',
        transitMax: 'Transit time, max days',
        returnDays: 'Return window (days)',
        returnDaysHint: '0 = no returns accepted',
        returnCosts: 'Return costs',
        returnFee: 'Return fee (cents)',
    },
    notifications: {
        title: 'Order notifications',
        email: 'Order notification email',
        emailPlaceholder: "sales{'@'}example.com, warehouse{'@'}example.com",
        help: 'Optional. One or more addresses (comma-separated) that receive a "new order placed" email when a customer pays. Leave blank to disable.',
    },
    countries: {
        title: 'Accepted countries',
        intro: 'The countries a shopper may pick on the storefront checkout and address forms. {warning}: checkout is blocked until you add at least one.',
        introWarning: 'Leave empty and no country can be selected',
        remove: 'Remove {country}',
        none: 'No countries enabled: the storefront checkout is currently blocked.',
        add: 'Add a country…',
    },
    sender: {
        title: 'Order mail sender',
        intro: "Optional override for order receipts and admin notifications. Leave blank to use the website's default sender.",
        fromEmail: 'From email',
        fromName: 'From name',
        noDefaultEmail: 'Set the website default first',
        defaultName: 'Falls back to website default',
    },
    payments: {
        title: 'Payment methods',
        intro: 'Enable the payment methods this website should offer at checkout. Each method must have all its credentials filled in before it can be enabled.',
        requires: 'requires {fields}',
        noCredentials: 'no credentials needed',
        credentialSaved: '•••••••• (saved, leave blank to keep)',
        displayName: 'Display name',
        blankUses: '(blank uses “{label}”)',
    },
};
